const globalSearch = {
  namespaced: true,
  state: {
    isClickEvaluateButton: false, //是否模拟点击评价按钮
    isHandleProject:false
  },
  mutations: {
    setClickEvaluateButton(state, val) {
      state.isClickEvaluateButton = val
    },
    setHandleProject(state, val) {
      state.isHandleProject = val
    },
  },
  actions: {}
}
export default globalSearch
